import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import { isElementInViewport } from '../Helpers';

export default class DefaultDatePicker extends Component {

  _DEFAULT_POSITION = 'bottom right';

  onShow(instance, animationComplete){

    if (!animationComplete){
      let isFit = false;

      // Loop through a few possible position and see which one fits
      $.each([
        this._DEFAULT_POSITION, 'top right', 'right center', 'right bottom', 'right top', 'top center', 'bottom center'
      ], function (i, position) {
        if (!isFit) {
          instance.update('position', position);
          let fits = isElementInViewport(instance.$datepicker[0]);
          if (fits.all) {
            isFit = true;
          }
        }
      });

    }
  }

  onHide(instance){
    // Update the position to the default again
    instance.update('position', this._DEFAULT_POSITION);
  }

  onSelect(formattedDate, date, instance) {
    $(instance.el).trigger('change');
  }

}